module.exports = __webpack_public_path__ + "img/outboundordernoselected.cbe944ff.jpg";